exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".role[data-v-8ccf7b84]{margin-bottom:2rem}.permissions[data-v-8ccf7b84]{display:flex;flex-wrap:wrap;list-style:none;padding-left:0;margin-bottom:0}.permissions__item[data-v-8ccf7b84]{margin:5px}", ""]);

// exports
